module.exports = __webpack_public_path__ + "img/Vectorleft.408cca9e.svg";